module.exports = __webpack_public_path__ + "img/gallery-levy2.ad823904.jpg";